import { FormCheckbox } from '@/components/form-checkbox';

export const SelectedReportFiles = () => {
  return (
    <div className="mb-4">
      <FormCheckbox
        name="acousticReport"
        labelKey="package-creation.acoustic-report"
      ></FormCheckbox>
      <FormCheckbox
        name="commissioningReport"
        labelKey="package-creation.commissioning-report"
      ></FormCheckbox>
      <FormCheckbox name="fireReport" labelKey="package-creation.fire-report"></FormCheckbox>
    </div>
  );
};
